import { CART_PRODUCT_MODEL_CLASS_NAME } from 'models/daos/cart-product/constants'
import { CART_MODEL_CLASS_NAME } from 'models/daos/cart/constants'
import getEndpointFromClassNameModelUtil from 'models/utils/get-endpoint-from-class-name'
import { resetCartProductAction } from 'modules/cart-products/actions'
import { CART_PRODUCTS_DOMAIN } from 'modules/cart-products/constants'
import {
  CART_DOMAIN,
  CART_ENDPOINT
} from 'modules/cart/constants'
import { hasCartProductsSelector } from 'modules/cart/selectors'
import { getValueCurrencySelector } from 'modules/currencies/selectors'
import getPathsEditingSelector from 'modules/editing/selectors/get-paths'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { getCurrentModalSelect } from 'modules/modal/selectors'
import { loadNotificationsAction } from 'modules/notifications/actions/load'
import { createRemoteInstanceLegacyRedux } from 'modules/redux/actions/legacy/create'
import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import { REDUX_DOMAIN } from 'modules/redux/constants'
import { getInstancesDomainSelector } from 'modules/redux/selectors/domain'
import getIdReduxUtil from 'modules/redux/utils/get-id'

import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import loadSectionAction from 'modules/section/actions/load'
import { resetShippingAction } from 'modules/shipping/actions/reset'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import { getObjectUtil } from 'packages/src'

// import isEditRouteUtil from 'modules/route/utils/is-edit'
function loadCartAction (options) {
  return loadLegacyReduxAction({
    endpoint: getEndpointFromClassNameModelUtil(CART_MODEL_CLASS_NAME),
    path: CART_DOMAIN,
    className: CART_MODEL_CLASS_NAME,
    options
  })
}

/**
 * Adds the product with the given id to the currentUser's Cart.
 * Then loads the notifications.
 * @param {Product} product
 * @param {number} productQuantityId
 * @param {string} [option]
 * @returns {Function}
 */
function addProductCartAction (product, productQuantityId, option) {
  return (dispatch, getState) => {
    const data = {
      id: getIdReduxUtil(product),
      productQuantityId,
      currencyValue: getValueCurrencySelector()(getState())
    }
    if (option) {
      data.option = option
    }
    return dispatch(
      createRemoteInstanceLegacyRedux({
        endpoint: CART_ENDPOINT.ADD_PRODUCT,
        path: CART_PRODUCTS_DOMAIN,
        className: CART_PRODUCT_MODEL_CLASS_NAME,
        data
      })
    ).then(() => {
      dispatch(
        openModalAction(MODAL_ID.CHECKOUT)
      )
      dispatch(
        loadNotificationsAction({ isForced: true })
      )
      dispatch(
        resetShippingAction()
      )
    })
  }
}

/**
 * Remove all cardProducts from the cart.
 * Often use after placing an order.
 * @returns {Function}
 */
function emptyCartAction () {
  return resetCartProductAction()
}

/**
 * Delay before the recommender is opened.
 * @private
 * @type {number}
 */
// const RECOMMENDER_DELAY = 1 * 60 * 1000
// const RECOMMENDER_DELAY = 1000
/**
 * Delay before the reminder is opened.
 * @private
 * @type {number}
 */
const REMINDER_DELAY = 3000

/**
 * Reminds the current User that their cart is not empty.
 * If it is, recommend products based on their genders.
 *
 * @returns {Function}
 */
function remindOrRecommendCartAction () {
  return (dispatch, getState) => {
    const currentUser = getCurrentUserSelector()(getState())
    if (getObjectUtil(currentUser, 'data.role')) {
      return
    }
    dispatch(loadProductsIfNecessaryCartAction())
    let delay
    let hasCartProducts = hasCartProductsSelector()(getState())
    if (hasCartProducts) {
      delay = REMINDER_DELAY
    } else {
      return // TODO update
      // delay = RECOMMENDER_DELAY
    }
    setTimeout(() => {
      // If a modal is opened, postpone
      const modalId = getCurrentModalSelect(getState())
      if (modalId) {
        dispatch(remindOrRecommendCartAction())
        return
      }
      // If a instance is being edited, postpone
      const editingPath = getPathsEditingSelector()(getState()) || []
      if (editingPath.length) {
        dispatch(remindOrRecommendCartAction())
        return
      }
      hasCartProducts = hasCartProducts()(getState())
      if (!hasCartProducts) {
        return
      }
      dispatch(
        remindCartAction()
      )
    }, delay)
  }
}

/**
 * Reminds the current User that they have Product(s) in their Cart.
 * @private
 * @returns {Function}
 */
function remindCartAction () {
  return openModalAction(MODAL_ID.CHECKOUT)
}

/**
 * Loads the Product(s) if there are none.
 * @private
 * @returns {Function}
 */
function loadProductsIfNecessaryCartAction () {
  return (dispatch, getState) => {
    const products = getInstancesDomainSelector(REDUX_DOMAIN.PRODUCTS)(getState())
    if (!products.length) {
      dispatch(
        loadSectionAction(ROUTE[ROUTE_PATH.STORE], {})
      )
    }
  }
}

export {
  loadCartAction,
  addProductCartAction,
  emptyCartAction,
  remindOrRecommendCartAction
}
